import { AppBar, Box, Button, Toolbar, Typography, IconButton, Menu, MenuItem } from '@mui/material'
import { getTranslation } from 'common'
import { useTranslations } from 'hooks';
import FlowentiLogo from "image/Logo.svg"
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom'
import MenuIcon from '@mui/icons-material/Menu';
import FlowentiButton from './flowenti-ui-kit/FlowentiButton';

const Navbar = ({ lang, isScrolled }: { lang?: string, isScrolled?: boolean }) => {
    const translations = useTranslations();
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

    const handleMenu = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const scrollToSection = (id: string) => {
        const element = document.getElementById(id);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
        }
        handleClose();
    };

    useEffect(() => {
        if (lang) {
            // console.log("Navbar lang:", lang);
        }
    }, [lang]);

    return (
        <AppBar
            position="sticky"
            elevation={0}
            sx={{
                backgroundColor: isScrolled ? "rgba(255, 255, 255, 0.95)" : "#f5f5f7",
                transition: "0.3s",
                borderBottom: isScrolled ? "1px solid rgba(0, 0, 0, 0.05)" : "1px solid transparent",
                backdropFilter: isScrolled ? "blur(12px)" : "none",
                boxShadow: isScrolled ? "0 1px 3px rgba(0, 0, 0, 0.05)" : "none",
            }}
        >
            <Toolbar sx={{
                display: "flex",
                justifyContent: "space-around",
                width: '100%',
                flexDirection: { xs: 'row-reverse', md: 'row' }
            }}>
                <Box component={Link} to="/" sx={{ display: "flex", alignItems: "center", textDecoration: "none" }}>
                    <img src={FlowentiLogo} alt="Flowenti Logo" style={{ height: 60 }} />
                    <Typography variant="h1" color="primary">Flowenti</Typography>
                </Box>
                <Box sx={{ display: { xs: 'none', md: 'flex' }, gap: 4, alignItems: "center", color: "gray" }}>
                    <Typography fontWeight={800} sx={{
                        textDecoration: 'none',
                        color: "gray",
                        cursor: 'pointer',
                        borderBottom: '2px solid transparent',
                        transition: 'border-bottom 0.2s ease-in-out',
                        '&:hover': {
                            borderBottom: '2px solid black'
                        },
                    }} onClick={() => scrollToSection('features')}>{getTranslation(translations, 'generic.features')}</Typography>
                    <Typography fontWeight={800} sx={{
                        textDecoration: 'none',
                        color: "gray",
                        cursor: 'pointer',
                        borderBottom: '2px solid transparent',
                        transition: 'border-bottom 0.2s ease-in-out',
                        '&:hover': {
                            borderBottom: '2px solid black'
                        },
                    }} onClick={() => scrollToSection('how-it-works')}>{getTranslation(translations, 'generic.howItWorks')}</Typography>
                    {/* <Typography fontWeight={800} component={Link}
                        to="/"
                        sx={{
                            textDecoration: 'none',
                            color: "gray",
                            cursor: 'pointer',
                            borderBottom: '2px solid transparent',
                            transition: 'border-bottom 0.2s ease-in-out',
                            '&:hover': {
                                borderBottom: '2px solid black'
                            },

                        }}>{getTranslation(translations, 'pm.propertyeditor.primaryproperties.label.documentation')}</Typography> */}
                    {/*waiting for docs on jenkins */}
                    <Typography fontWeight={800} component={Link}
                        to="/billing" sx={{
                            textDecoration: 'none',
                            color: "gray",
                            cursor: 'pointer',
                            borderBottom: '2px solid transparent',
                            transition: 'border-bottom 0.2s ease-in-out',
                            '&:hover': {
                                borderBottom: '2px solid black'
                            },
                        }} >{getTranslation(translations, 'general_billing.plans')}</Typography>
                </Box>
                <Box sx={{ display: { xs: 'none', md: 'flex' }, gap: 1, alignItems: 'center' }}>
                    <Typography
                        color="black"
                        variant='caption'
                        fontWeight={800}
                        component={Link}
                        to="/login"
                        sx={{
                            borderBottom: '2px solid transparent',
                            textDecoration: 'none', cursor: 'pointer', mr: 2, transition: 'border-bottom 0.2s ease-in-out',
                            '&:hover': {
                                borderBottom: '2px solid black'
                            },
                        }}
                    >
                        Login
                    </Typography>
                    <FlowentiButton
                        component={Link}
                        to="/registration"
                        size="small"
                        variant="contained"
                    >
                        {getTranslation(translations, 'generic.start_for_free')}
                    </FlowentiButton>
                </Box>
                <Box sx={{ display: { xs: 'flex', md: 'none' } }}>
                    <IconButton
                        size="large"
                        edge="start"
                        color="inherit"
                        aria-label="menu"
                        onClick={handleMenu}
                        sx={{ color: 'primary.main' }}
                    >
                        <MenuIcon />
                    </IconButton>
                    <Menu
                        id="menu-appbar"
                        anchorEl={anchorEl}
                        anchorOrigin={{
                            vertical: 'top',
                            horizontal: 'right',
                        }}
                        keepMounted
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'right',
                        }}
                        open={Boolean(anchorEl)}
                        onClose={handleClose}
                    >
                        <MenuItem onClick={handleClose}>{getTranslation(translations, 'generic.features')}</MenuItem>
                        <MenuItem onClick={handleClose}>{getTranslation(translations, 'generic.howItWorks')}</MenuItem>
                        {/* <MenuItem onClick={handleClose}>{getTranslation(translations, 'pm.propertyeditor.primaryproperties.label.documentation')}</MenuItem> */}
                        <MenuItem onClick={handleClose}>{getTranslation(translations, 'general_billing.plans')}</MenuItem>
                        <MenuItem component={Link} to="/login" onClick={handleClose}>Login</MenuItem>
                        <MenuItem component={Link} to="/registration" onClick={handleClose}>{getTranslation(translations, 'generic.start_for_free')}</MenuItem>
                    </Menu>
                </Box>
            </Toolbar>
        </AppBar>
    )
}

export default Navbar